export class NameValString {
  public Name: string;
  public Value: string;

  public constructor(itemName?: string, itemValue?: string) {
    if (itemName == null || itemName == undefined) {
      this.Name = '';
    } else {
      this.Name = itemName;
    }
    if (itemValue == null || itemValue == undefined) {
      this.Value = null;
    } else {
      this.Value = itemValue;
    }
  }
}
